import React, {ReactNode} from 'react';

import * as CRISPRConstants from 'constants/CRISPRConstants';
import {URLS, ValueLink} from 'constants/CRISPRConstants';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import HelpIcon from 'ui-library/icons/HelpIcon';
import PopoverIcon from 'ui-library/PopoverIcon';

import PAMSelector from './PAMSelector';

const PAM_NAG_WARNING = (
  <div>
    NAG has been shown to have lower efficiency than NGG for SpCas9.
    <a href={URLS.NGG_PAM} target="_blank" rel="noopener noreferrer">
      <HelpIcon />
    </a>
  </div>
);

const BASE_EDIT_PAM_WARNING = `Base-editing scores are based on empirical data of BE1 activity using \
an ${CRISPRConstants.BASE_EDIT_SCORING_PAM} PAM. These scores may not reflect the real activity \
of other base editors.`;

const SPCAS9_DESIGN_TYPES = [CRISPRConstants.DESIGN_TYPE.SINGLE, CRISPRConstants.DESIGN_TYPE.PAIRED];

interface Props {
  pamLink: ValueLink<string>;
  disabled?: boolean;
  helpText?: string;
  designType?: CRISPRConstants.DESIGN_TYPE;
}

class PAMSelectorGroup extends React.Component<Props> {
  getWarningMessage = (): ReactNode => {
    if (
      this.props.pamLink.value === 'NAG' &&
      this.props.designType &&
      SPCAS9_DESIGN_TYPES.includes(this.props.designType)
    ) {
      return PAM_NAG_WARNING;
    } else if (
      this.props.pamLink.value !== CRISPRConstants.BASE_EDIT_SCORING_PAM &&
      this.props.designType === CRISPRConstants.DESIGN_TYPE.BASE_EDIT
    ) {
      return BASE_EDIT_PAM_WARNING;
    }
    return null;
  };

  render(): JSX.Element {
    return (
      <FormGroup>
        <Row>
          <Col className="text-right" sm={3}>
            <Label className="u-input-line-height">PAM</Label>
          </Col>
          <Col sm={8}>
            {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'isLeftPam' is missing in type '{ value: ... Remove this comment to see the full error message */}
            <PAMSelector pamLink={this.props.pamLink} disabled={this.props.disabled} />
            {this.props.helpText != null ? <p className="help-block">{this.props.helpText}</p> : null}
          </Col>
          {this.getWarningMessage() != null ? (
            <Col sm={1}>
              <PopoverIcon
                className="u-input-line-height u-warning-color"
                icon="warning"
                renderContent={() => this.getWarningMessage()}
                placement={FloatingPlacement.LEFT}
              />
            </Col>
          ) : undefined}
        </Row>
      </FormGroup>
    );
  }
}

export default PAMSelectorGroup;
